import { Group, Loader, Stack } from "@mantine/core";
import NoData from "@/components/no-data/NoData";
import RankingDeColaboradorCard from "./RankingDeColaboradorCard";
import useGetRankingRegulamentoPerColaborador from "./useGetRankingRegulamentoPerColaborador";
// prettier-ignore
const RankingDeColaboradoresList = ({ regulamento }: { regulamento: TRegulamentoIdeias }) => {
  const { data: rankingPerColaborador, isLoading } = useGetRankingRegulamentoPerColaborador(regulamento);
  if (isLoading) {
    return <Group justify={"center"}>
      <Loader color="blue" />
    </Group>;
  }

  if (!rankingPerColaborador || rankingPerColaborador.length === 0) {
    return <NoData title="Nenhuma movimentação encontrada!">Tente selecionar outro ano</NoData>;
  }

  return (
    <Stack gap="xs">
      {rankingPerColaborador.map((ranking) => (
        <RankingDeColaboradorCard key={ranking.id} regulamento={regulamento} ranking={ranking} />
      ))}
    </Stack>
  );
};

export default RankingDeColaboradoresList;
